import * as React from "react";
import { forwardRef } from "react";
const SvgTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "#aaa", viewBox: "0 0 640 640", shapeRendering: "geometricPrecision", textRendering: "geometricPrecision", imageRendering: "optimizeQuality", fillRule: "evenodd", clipRule: "evenodd", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M639.965.024L640 639.953l-640.012.023z" }));
const ForwardRef = forwardRef(SvgTriangle);
export default ForwardRef;
